<template>
  <v-container full-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="primary" title="Edit Customer" text="Complete customer details">
          <v-form @submit.prevent="saveCustomer">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs-12 md4>
                  <v-switch
                    :disabled="!is_Edit"
                    label="Active"
                    color="primary"
                    value
                    input-value="true"
                    v-model="model.isActive"
                  ></v-switch>
                </v-flex>
                <v-flex xs-12 md4>
                  <v-switch
                    :disabled="is_Edit"
                    :label="switchText"
                    color="primary"
                    value
                    input-value="true"
                    v-model="is_Company"
                  ></v-switch>
                </v-flex>
                <v-flex xs-12 md4></v-flex>

                <v-flex xs-12 md4>
                  <v-text-field label="Customer ID" disabled v-model="model.customer_external_id"></v-text-field>
                </v-flex>
                <v-flex xs-12 md4>
                  <v-text-field
                    label="Name"
                    class="purple-input"
                    v-model="model.name"
                    name="name"
                    v-validate="'required|max:50'"
                    :counter="250"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs-12 md4>
                  <v-select :items="statusTypes" label="Status" v-model="model.status"></v-select>
                </v-flex>
                <v-flex xs-12 md4>
                  <v-text-field
                    label="Email"
                    class="purple-input"
                    v-model="email"
                    name="email"
                    v-validate="'required|email|max:250'"
                    :counter="250"
                    :error-messages="errors.collect('email')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs-12 md4>
                  <v-text-field
                    label="Phone"
                    class="purple-input"
                    v-model="formattedPhoneValue"
                    name="phone"
                    v-validate="'required'"
                    :error-messages="errors.collect('phone')"
                    @keyup="focusOut"
                    @blur="focusOut"
                  ></v-text-field>
                </v-flex>
                 <v-flex xs-12 md4>
                  <v-text-field
                    v-if="is_Company"
                    label="Primary Contact"
                    class="purple-input"
                    v-model="primaryContact"
                    name="Primary contact"
                    v-validate="'required'"
                    :error-messages="errors.collect('Primary contact')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    label="Street Adress"
                    class="purple-input"
                    v-model="address"
                    name="address"
                    v-validate="'required|max:250'"
                    :counter="250"
                    :error-messages="errors.collect('address')"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="City"
                    class="purple-input"
                    v-model="city"
                    name="city"
                    v-validate="'required|max:50'"
                    :counter="50"
                    :error-messages="errors.collect('city')"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="purple-input"
                    label="Zip"
                    v-model="zip"
                    name="zip"
                    v-validate="'required|digits:5'"
                    :error-messages="errors.collect('zip')"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="State" class="purple-input" v-model="state"/>
                </v-flex>

                <v-flex xs12 md12>
                  <v-combobox
                    multiple
                    v-model="select"
                    label="Tags"
                    append-icon
                    chips
                    deletable-chips
                    :search-input.sync="search"
                    @keyup.tab="updateTags"
                    @paste="updateTags"
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md12>
                  <v-btn type="submit" color="primary">Save</v-btn>
                  <v-btn type="cancel" color="grey">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerService from "@/api-services/customer.service.js";
import _ from "lodash";
import { error } from "util";
import router from "@/router";

export default {
  data: () => ({
    //Flags
    is_Edit: false,
    is_Company: true,

    //model values
    switchText: "Company",
    primaryContact:"",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",

    formattedPhoneValue: "",
    preventNextIteration: false,

    emailTypes: ["Primary", "Work", "Personal"],
    phoneTypes: ["Primary", "Mobile", "Work", "Home"],
    statusTypes: ["Prospect", "Client"],

    //For tags
    select: [],
    search: "", //sync search

    //customer model
    model: {
      customer_external_id:
        "C" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1,
      imageURL: "",
      is_company: true,
      is_active: true,
      status: "Client",
      email: [],
      phone: [],
      address: []
    }
  }),
  methods: {
    saveCustomer() {
      this.$validator.validateAll().then(result => {
        if (result) {
          //Assign values to model
          this.model.tags = this.select;
          this.model.is_company = this.is_Company;
          this.model.email.push({ type: "primary", email: this.email });
          this.model.phone.push({
            type: "primary",
            phone: this.formattedPhoneValue
          });
          this.model.address.push({
            type: "main",
            address1: this.address,
            address2: "",
            city: this.city,
            state: this.state,
            zip: this.zip
          });
          this.model.active_since = new Date();

          //Save model in DB
          console.log(this.model);
          CustomerService.create(this.model)
            .then(response => {
              console.log(response);
              if (response.status == 200) {
                this.$toasted.show(
                  "Customer added successfully. Now add your coverages.",
                  {
                    theme:"bubble",
                    position: "top-right",
                    duration: 5000,
                    onClick : (e, toastObject) => {
                toastObject.goAway(0);
            }
                  }
                );
                router.push({
                  name: "Customer Detail",
                  params: { id: this.model.customer_external_id }
                });
              }
            })
            .catch(error => {
              console.log(error);
              this.$toasted.show(error);
            });
        }
      });
    },
    updateTags() {
      this.$nextTick(() => {
        this.select.push(...this.search.split(","));
        this.$nextTick(() => {
          this.search = "";
        });
      });
    },
    focusOut: function(event) {
      if (["Arrow", "Backspace", "Shift"].includes(event.key)) {
        this.preventNextIteration = true;
        return;
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false;
        return;
      }
      this.phone = this.formattedPhoneValue
        .replace(/-/g, "")
        .match(/(\d{1,10})/g)[0];

      // Format display value based on calculated currencyValue
      this.formattedPhoneValue = this.phone.replace(
        /(\d{1,3})(\d{1,3})(\d{1,4})/g,
        "$1-$2-$3"
      );
    }
  },
  watch: {
    is_Company() {
      this.switchText = this.is_Company ? "Company" : "Individual";
      if (this.is_Edit === false) {
        this.model.customer_external_id =
          (this.is_Company ? "C" : "I") +
          Math.floor(Math.random() * (1000000000 - 1 + 1)) +
          1;
      }
    }
  }
};
</script>

<style>
</style>
